import { Modal } from '@material-ui/core'
import PropTypes from 'prop-types'

import { H3, Text } from '../../../styles/typography'
import Button from '../../button'
import { DetailViewEl } from '../elements'

const DetailView = ({ close, data }) => {
  return (
    <Modal onClose={close} open>
      <DetailViewEl>
        <div className='logo'>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img alt={data?.name} src={data?.logo} />
        </div>
        <div className='details'>
          <Text>{data?.brandComment}</Text>
          <H3>{data?.artistComment}</H3>
          <div className='actions'>
            <Button onClick={() => close()} theme='secondary'>
              Close
            </Button>

            <a href={data?.link} rel='noreferrer' target='_blank'>
              <Button theme='primary'>Visit Site</Button>
            </a>
          </div>
        </div>
      </DetailViewEl>
    </Modal>
  )
}

export default DetailView

DetailView.propTypes = {
  close: PropTypes.func.isRequired,
  data: PropTypes.shape({
    artistComment: PropTypes.string.isRequired,
    brandComment: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    logo: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
}
